module.exports = __webpack_public_path__ + "static/media/hero-bg1.77c8bfc4.png";